import * as Yup from 'yup';

export const categoryFormSchema = Yup.object().shape({
  serviceCategoryName: Yup.string().required('Name is required'),
});
